import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OldDataService } from 'src/app/core/services/old-data.service';
import Swal from 'sweetalert2';
import { OrdersService } from '../../services/orders/orders.service';
import { getFirebaseBackend } from 'src/app/authUtils';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { CampaignService } from '../../services/campaigns/campaign.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { CampaignWizardComponent } from 'src/app/shared/wizards/campaign-wizard/campaign-wizard.component';
import { INDUSTRIES } from 'src/app/shared/constants';
import { ProspectsService } from 'src/app/services/prospects/prospects.service';

@Component({
	selector: 'app-campaigns',
	templateUrl: './campaigns.component.html',
	styleUrls: ['./campaigns.component.scss'],
})
export class CampaignsComponent implements OnInit {
	@ViewChild(DatatableComponent) table: DatatableComponent;

	public user: any;
	public campaignsLoading: boolean;
	public campaignsMetadataLoading: boolean;
	public campaigns: any;
	public campaignsMsg: string;
	public campaignUpdate: any;
	public campaignTab: string;
	public pendingRescheduleQuantity: number = 0;

	public reschedule: any;
	public active: any;
	public inactive: any;
	public countCampaign: any;

	public leadsSum: number;
	public pointsSum: number;

	public activeCampaigns: any;
	public inactiveCampaigns: any;

	public leads_needed: number;
	public leadsNeededLoading: boolean;

	public multiple_leads_needed: number;
	public campaign_needed: any;

	public resetLoading: boolean;

	public adminCampaignsConfig = {
		tableClass: 'table-hover',
		theadClass: 'thead-dark',
		dblclickRows: true,
	};

	public adminCampaignsButtons = [];

	title_reserve: string = '';
	text_leads_reserve: string = '';
	overview_leads: string = '';
	industries = INDUSTRIES;

	// NGX Datatables
	columns = [{ prop: 'name' }, { name: 'Company' }, { name: 'Gender' }];
	rows = [];
	// ColumnMode = ColumnMode;
	temp = [];

	footerTotals = {
		activeScore: 0,
		inactiveScore: 0,
		activeNeeded: 0,
		inactiveNeeded: 0,
		activeReschedule: 0,
		inactiveReschedule: 0,
	};

	private actionAlert = Swal.mixin({
		customClass: {
			popup: 'swal-action-popup',
			title: 'swal-action-title',
			htmlContainer: 'swal-action-text',
			actions: 'swal-action-buttons',
		},
		buttonsStyling: false,
		position: 'center',
		reverseButtons: true,
	});

	sortColumn: string = '';
	sortDirection: 'asc' | 'desc' = 'asc';

	reserveCampaign: any = null;
	reserveSummary: any = null;
	reserveMovements: any[] = [];
	reserveAmount: number = null;
	reserveLoading: boolean = false;
	reserveSaving: boolean = false;

	constructor(
		private modalService: NgbModal,
		private router: Router,
		public utils: UtilsService,
		private dataService: OldDataService,
		private ordersService: OrdersService,
		private campaignSrv: CampaignService,
		private prospectSrv: ProspectsService,
	) {
		this.campaignsLoading = false;
		this.campaignsMetadataLoading = true;
		this.leadsNeededLoading = false;
		this.leadsSum = 0;
		this.pointsSum = 0;
		this.resetLoading = false;
	}

	ngOnInit() {
		this.user = getFirebaseBackend()?.getAuthenticatedUser();
		this.user.login = this.user.Login;
		this.getAllCampaigns();
		this.campaignSrv.countPendingRescheduleLeads().subscribe((data) => {
			this.reschedule = data.body[0].cantidad;
		});

		this.campaignSrv.getCampaignsCount(1).subscribe((data) => {
			this.active = data.body[0].cantidad;
		});

		this.campaignSrv.getCampaignsCount(0).subscribe((data) => {
			this.inactive = data.body[0].cantidad;
		});

		// this.countPendingRescheduleLeads();
	}

	validateMultipleLeadsNeeded() {
		if (this.multiple_leads_needed && this.multiple_leads_needed >= 0 && this.multiple_leads_needed <= 100) {
			Swal.fire('From now on the following campaigns you select will be updated with the number you write, the previous ones will remain as they are with the value they have now.');
		}
	}

	changeCampaignNeeded(id) {
		if (this.multiple_leads_needed && this.multiple_leads_needed >= 0 && this.multiple_leads_needed <= 100) {
			this.leadsNeededLoading = true;

			const payload = {
				campaign_id: id,
				leads_needed: this.multiple_leads_needed,
			};

			this.campaignSrv.updateLeadsNeeded(payload).subscribe((data) => {
				Swal.fire('Leads Needed have been successfully updated');
			});
		} else {
			var checked = <HTMLInputElement>document.getElementById('checkbox_' + id);
			checked.checked = false;
			Swal.fire('You need to fill out the "Leads Needed" field to be able to make changes');
		}
	}

	closeNeededModal() {
		this.leadsNeededLoading = true;
		this.getAllCampaigns();
		this.leadsNeededLoading = false;
	}

	validateLeadsNeeded() {
		const campaign = this.campaignUpdate;
		const newLeadsNeeded = this.leads_needed;

		if (newLeadsNeeded && newLeadsNeeded >= 0 && newLeadsNeeded <= 100 && newLeadsNeeded != campaign.leads_needed) {
			this.confirmAction({
				title: 'Update leads needed for ' + campaign.name + '?',
				text: 'The leads needed will be changed from ' + campaign.leads_needed + ' to ' + newLeadsNeeded + '.',
				icon: 'ri-refresh-line',
				colorClass: 'success',
				confirmText: 'Yes, save',
			}).then((result) => {
				if (!result.value) return;
				this.saveLeadsNeeded(campaign, newLeadsNeeded);
			});
		} else {
			Swal.fire('Invalid');
		}
	}

	saveLeadsNeeded(campaign = this.campaignUpdate, leadsNeeded = this.leads_needed) {
		this.leadsNeededLoading = true;

		const payload = {
			campaign_id: campaign.id,
			leads_needed: leadsNeeded,
		};

		this.campaignSrv.updateLeadsNeeded(payload).subscribe((data) => {
			this.getAllCampaigns();
			this.leadsNeededLoading = false;
			Swal.fire('Leads Needed have been successfully updated');
		});
	}
	getAllCampaigns() {
		this.campaignsLoading = true;
		this.campaigns = null;
		this.activeCampaigns = [];
		this.inactiveCampaigns = [];

		this.campaignSrv.getAllCampaigns().subscribe((data: any) => {
			data.body.map((campaign) => {
				campaign.icons = [
					{
						name: 'ri-download-2-line',
						action: 'downloadConfirm',
						tooltip: 'Download Records',
						align: 'right',
						color: 'btn-primary',
					},
					{
						name: 'ri-calendar-2-fill',
						action: 'openCalendar',
						tooltip: 'Open Calendar',
						align: 'right',
						color: 'btn-warning',
					},
					{
						name: 'ri-refresh-line',
						action: 'resetHopperConfirm',
						tooltip: 'Reset Hopper',
						align: 'right',
						color: 'btn-success',
					},
				];
				// TODO: Change this hardcoded users to roles
				// if (this.user.Login == 'ltest' || this.user.Login === 'ltejeda' || this.user.Login === 'vkapella' || this.user.Login === 'tgarcia') {
				if (this.user.Role === 'SADM') {
					campaign.icons.push({
						name: 'ri-delete-bin-fill',
						action: 'deleteProspects',
						tooltip: 'Unassign All prospects from Campaign',
						align: 'right',
						color: 'btn-danger',
					});
				}

				if (campaign.isActive == 1) {
					campaign.icons.push({
						name: 'ri-recycle-line',
						action: 'openNeeded',
						tooltip: 'Set Needed',
						align: 'right',
						color: 'btn-success',
					});
				}

				if (campaign.isActive == 1) {
					this.activeCampaigns.push(campaign);
				} else if (campaign.isActive == 0) {
					this.inactiveCampaigns.push(campaign);
				}

				if (campaign.types != null) {
					campaign.types = this.utils.getTypesIcons(campaign.types);
				}

				this.campaignsLoading = false;
			}); // End Map (foreach)
			this.campaignSrv.getAllCampaignsMedatada().subscribe((data: any) => {
				this.activeCampaigns.map((campaign) => {
					const metadata = data.body.find((meta) => {
						return meta.id === campaign.id;
					});
					campaign.porcentaje = parseFloat(metadata.porcentaje).toFixed(2);
					campaign.pending_reschedule = metadata.pending_reschedule;
					campaign.records = metadata.records;
					this.footerTotals.activeScore += parseFloat(campaign.porcentaje != null ? campaign.porcentaje : '0');
					this.footerTotals.activeNeeded += parseInt(campaign.leads_needed != null ? campaign.leads_needed : '0');
					this.footerTotals.activeReschedule += parseInt(campaign.pending_reschedule != null ? campaign.pending_reschedule : '0');
				});

				this.inactiveCampaigns.map((campaign) => {
					const metadata = data.body.find((meta) => {
						return (meta.id = campaign.id);
					});

					campaign.porcentaje = parseFloat(metadata.porcentaje).toFixed(2);
					campaign.pending_reschedule = metadata.pending_reschedule;
					this.footerTotals.inactiveScore += parseFloat(campaign.porcentaje != null ? campaign.porcentaje : '0');
					this.footerTotals.inactiveNeeded += parseInt(campaign.leads_needed != null ? campaign.leads_needed : '0');
					this.footerTotals.inactiveReschedule += parseInt(campaign.pending_reschedule != null ? campaign.pending_reschedule : '0');
				});
				this.campaignsMetadataLoading = false;
			});

			this.toggleCampaignList('active');
			// Segunda llamada
			// campaign.porcentaje = parseFloat(
			// 	campaign.porcentaje
			// ).toFixed(2);

			// is activo totals
			// this.footerTotals.activeScore += parseFloat(campaign.porcentaje != null ? campaign.porcentaje : '0');
			// 		this.footerTotals.activeNeeded += parseInt(campaign.leads_needed != null ? campaign.leads_needed : '0');
			// 		this.footerTotals.activeReschedule += parseInt(campaign.pending_reschedule != null ? campaign.porcentpending_rescheduleaje : '0');

			// no active totals
			// this.footerTotals.inactiveScore += parseFloat(campaign.porcentaje != null ? campaign.porcentaje : '0');
			// 		this.footerTotals.inactiveNeeded += parseInt(campaign.leads_needed != null ? campaign.leads_needed : '0');
			// 		this.footerTotals.inactiveReschedule += parseInt(campaign.pending_reschedule != null ? campaign.porcentpending_rescheduleaje : '0');
		});

		// this.dataService.post(url, { admin: true }).then((data) => {
		// 	if (data) {
		// 		if (data.records && data.records.length && !data.error) {
		// 			data.records.map((campaign) => {
		// 				campaign.icons = [
		// 					{
		// 						name: "ri-download-2-line",
		// 						action: "downloadConfirm",
		// 						tooltip: "Download Records",
		// 						align: "right",
		// 						color: "btn-primary"
		// 					},
		// 					{
		// 						name: "ri-calendar-2-fill",
		// 						action: "openCalendar",
		// 						tooltip: "Open Calendar",
		// 						align: "right",
		// 						color: "btn-warning"
		// 					},
		// 					{
		// 						name: "ri-refresh-line",
		// 						action: "resetHopperConfirm",
		// 						tooltip: "Reset Hopper",
		// 						align: "right",
		// 						color: "btn-success"
		// 					},
		// 				];
		// 				// TODO: Change this hardcoded users to roles
		//                 if(this.user.Login == 'ltest' ||this.user.Login === 'ltejeda' || this.user.Login === 'vkapella' || this.user.Login === 'tgarcia'){
		// 					campaign.icons.push({
		// 						name: "ri-delete-bin-fill",
		// 						action: "deleteProspects",
		// 						tooltip: "Delete Prospects List",
		// 						align: "right",
		// 						color: "btn-danger"
		// 					})
		//                 }

		// 				campaign.porcentaje = parseFloat(
		// 					campaign.porcentaje
		// 				).toFixed(2);

		// 				if (campaign.isActive == 1) {
		// 					campaign.icons.push({
		// 						name: "ri-recycle-line",
		// 						action: "openNeeded",
		// 						tooltip: "Set Needed",
		// 						align: "right",
		// 						color: "btn-success"
		// 					});
		// 				}

		// 				if (campaign.isActive == 1) {
		// 					this.footerTotals.activeScore += parseFloat(campaign.porcentaje != null ? campaign.porcentaje : '0');
		// 					this.footerTotals.activeNeeded += parseInt(campaign.leads_needed != null ? campaign.leads_needed : '0');
		// 					this.footerTotals.activeReschedule += parseInt(campaign.pending_reschedule != null ? campaign.porcentpending_rescheduleaje : '0');
		// 					this.activeCampaigns.push(campaign);
		// 				} else if (campaign.isActive == 0) {
		// 					this.footerTotals.inactiveScore += parseFloat(campaign.porcentaje != null ? campaign.porcentaje : '0');
		// 					this.footerTotals.inactiveNeeded += parseInt(campaign.leads_needed != null ? campaign.leads_needed : '0');
		// 					this.footerTotals.inactiveReschedule += parseInt(campaign.pending_reschedule != null ? campaign.porcentpending_rescheduleaje : '0');
		// 					this.inactiveCampaigns.push(campaign);
		// 				}

		// 				if (campaign.types !=null){
		// 					campaign.types = this.utils.getTypesIcons(campaign.types);
		// 				}

		// 			});

		// 			this.toggleCampaignList("active");
		// 		} else if (data.error) {
		// 			this.campaignsMsg = data.message;
		// 			this.campaignsLoading = false;

		// 			if (data.status && data.status === 401) {
		// 				// this.authenticationService.logout(
		// 				// 	"-------------------getAllCampaigns"
		// 				// );
		// 				location.reload();
		// 			}
		// 		}
		// 	} else {
		// 		this.campaignsMsg = "ERROR.";
		// 		this.campaignsLoading = false;
		// 	}
		// });
	}

	toggleCampaignList(type: string) {
		this.campaignTab = type;

		setTimeout(() => {
			this.campaigns = type === 'active' ? this.activeCampaigns : this.inactiveCampaigns;

			this.getCampaignSums(this.campaigns);

			this.temp = [...this.campaigns];
		});
	}

	getCampaignSums(arr) {
		let leadsSum = 0;
		let pointsSum = 0;
		for (let i = 0; i < arr.length; i++) {
			leadsSum += parseInt(arr[i].leads_needed);
			pointsSum += parseInt(arr[i].points);
		}
		this.leadsSum = leadsSum;
		this.pointsSum = pointsSum;
		this.campaignsLoading = false;
	}

	addCampaign() {
		//Esto es lo que estaba ahora abriremos un modal con el componente Campaign Wizard
		// this.router.navigate(["/campaign-add"]);

		const modalRef = this.modalService.open(CampaignWizardComponent, {
			size: 'lg',
			centered: true,
			backdrop: 'static',
		});

		modalRef.result.then(
			(result) => {
				this.getAllCampaigns();
			},
			(reason) => {},
		);
	}

	resetNeededConfirmAll() {
		Swal.fire({
			title: 'Reset the Needed for All Campaigns?',
			text: 'ARE YOU SURE? Please have all agents log out.',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.resetAllNeeded();
			}
		});
	}

	/**
	 * Open modal
	 * @param content modal content
	 */
	openModal(content: any) {
		this.modalService.open(content, {
			size: 'fullscreen',
			windowClass: 'modal-holder',
		});
	}

	resetAllNeeded() {
		this.resetLoading = true;

		this.campaignSrv.resetAllNeededCampaigns().subscribe((data: any) => {
			if (data.body.success) {
				Swal.fire('All Campaigns Leads Needed was reset correctly');
				this.getAllCampaigns();
			} else if (data.error) {
				Swal.fire(data.body.error);
			}
			this.resetLoading = false;
		});
	}

	resetHopperConfirmAll() {
		Swal.fire({
			title: 'Reset the Hopper for All Campaigns?',
			text: 'ARE YOU SURE? Please have all agents log out.',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.resetHopperAll();
			}
		});
	}

	async resetHopperAll() {
		// this.resetLoading = true;
		const campaignsIds = this.campaigns.map((campaign) => {
			return campaign.id;
		});

		for (const campaignId of campaignsIds) {
			await this.resetCampaingRecords(campaignId);
		}
	}

	resetCampaingRecords(campaignId) {
		return new Promise((resolve, reject) => {
			this.campaignSrv.assignRecordsToCampaign(campaignId).subscribe((data) => {
				resolve(data);
			});
		});
	}

	iconPressed(icon, modal) {
		switch (icon.icon) {
			case 'downloadConfirm':
				this.downloadRecords(icon.record);
				break;
			case 'openCalendar':
				this.openCalendar(icon.record.id, icon.record.alias);
				break;
			case 'openNeeded':
				this.openNeeded(modal, icon.record);
				break;
			case 'resetHopperConfirm':
				// this.resetHopperConfirm(icon.record);
				this.assignRecordsToCampaign(icon.record);
				break;
			case 'deleteProspects':
				this.deleteProspectsFromCampaign(icon.record);
				break;
			default:
				break;
		}
	}

	// downloadConfirm(campaign: any) {
	// 	Swal.fire({
	// 		title: "Download records for " + campaign.name + "?",
	// 		text: "ARE YOU SURE?",
	// 		showCancelButton: true,
	// 		confirmButtonText: "Yes",
	// 		cancelButtonText: "Cancel",
	// 	}).then((result) => {
	// 		if (result.value) {
	// 			this.downloadRecords(campaign);
	// 		}
	// 	});
	// }

	downloadRecords(campaign) {
		this.confirmAction({
			title: 'Download records for ' + campaign.name + '?',
			text: 'A CSV file with the campaign records will be downloaded.',
			icon: 'ri-download-2-line',
			colorClass: 'primary',
			confirmText: 'Yes, download',
		}).then((result) => {
			if (!result.value) return;

			this.actionAlert.fire({
				title: 'Downloading Records',
				html: '<i class="ri-download-2-line swal-action-icon swal-icon-primary"></i>',
				allowOutsideClick: false,
				showConfirmButton: false,
				didOpen: () => Swal.showLoading(),
			});

			const payload = { campaign_id: campaign.id };
			this.campaignSrv.downloadCampaignRecords(payload).subscribe((data: any) => {
				Swal.close();
				if (data) {
					if (data.records && data.records.length && !data.error) {
						const url = window.URL.createObjectURL(new Blob([data.fileContent]));
						const link = document.createElement('a');
						link.href = url;
						link.setAttribute('download', `${campaign.name}_Records.csv`);
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.resultAlert('Success', 'Records downloaded successfully', 'ri-checkbox-circle-line', 'success');
					} else if (data.error) {
						this.resultAlert('Download Failed', data.message, 'ri-error-warning-line', 'danger');
						if (data.status && data.status === 401) {
							location.reload();
						}
					}
				} else {
					this.resultAlert('Download Failed', 'Download Failed.', 'ri-error-warning-line', 'danger');
				}
			});
		});
	}

	openNeeded(needed, campaign) {
		this.campaignUpdate = campaign;
		if (campaign.campaign_type == 'R' || campaign.campaign_type == 'H') {
			let total = 0;
			this.campaignSrv.getLeadsStatus(campaign.id).subscribe((data: any) => {
				if (!data.hasOwnProperty('error')) {
					if (data.body.length > 0) {
						data.body.forEach((dataLeads) => {
							if (dataLeads.title_status == 'Total Leads') {
								total = dataLeads.count_leads;
							} else {
								this.overview_leads += dataLeads.title_status + ': ' + dataLeads.count_leads + ', ';
							}
						});
						this.overview_leads = this.overview_leads.substring(0, this.overview_leads.length - 2);

						this.ordersService.getDataOrderByCampaign(campaign.id).subscribe((data: any) => {
							if (!data.hasOwnProperty('error')) {
								if (data.body.length > 0) {
									let order_info = data.body;

									if (campaign.campaign_type == 'R') {
										this.title_reserve = 'There have been ' + total + ' leads from reserve set so far for this client!';
										this.text_leads_reserve = 'Total reserve is ' + order_info[0].total_leads + ' for this order date: ' + order_info[0].start_date;
									} else {
										this.title_reserve = 'There have been ' + total + ' leads from hourly set so far for this client!';
										this.text_leads_reserve = 'Total hours in hourly is ' + order_info[0].total_hours + ' for this order date: ' + order_info[0].start_date;
									}
								} else {
									this.title_reserve = '';
									this.text_leads_reserve = '';
								}
							}
						});

						this.modalService.open(needed, { centered: true }).result.then(
							(result) => {
								this.campaignUpdate = null;
								this.leads_needed = null;
								this.title_reserve = '';
								this.overview_leads = '';
							},
							(reason) => {
								this.campaignUpdate = null;
								this.leads_needed = null;
								this.title_reserve = '';
								this.overview_leads = '';
							},
						);
					}
				}
			});
		} else {
			this.modalService.open(needed, { centered: true }).result.then(
				(result) => {
					this.campaignUpdate = null;
					this.leads_needed = null;
					this.title_reserve = '';
				},
				(reason) => {
					this.campaignUpdate = null;
					this.leads_needed = null;
					this.title_reserve = '';
				},
			);
		}
	}
		openReserve(modal: any, campaign: any) {
		this.reserveCampaign = campaign;
		this.reserveAmount = null;
		this.loadReserve();

		this.modalService.open(modal, { size: 'lg', centered: true }).result.then(
			() => (this.reserveCampaign = null),
			() => (this.reserveCampaign = null),
		);
	}

	loadReserve() {
		this.reserveLoading = true;

		this.campaignSrv.getReserveMovements(this.reserveCampaign.id).subscribe({
			next: (res: any) => {
				this.reserveSummary = res.body?.summary;
				this.reserveMovements = res.body?.movements ?? [];
				this.reserveLoading = false;
			},
			error: () => {
				this.reserveSummary = null;
				this.reserveMovements = [];
				this.reserveLoading = false;
			},
		});
	}

	addReserveDeposit() {
		const amount = Number(this.reserveAmount);

		if (!amount || amount <= 0) {
			this.resultAlert('Invalid amount', 'Enter an amount greater than 0.', 'ri-error-warning-line', 'danger');
			return;
		}

		this.confirmAction({
			title: 'Add deposit to ' + this.reserveCampaign.name + '?',
			text: 'A deposit of $' + amount.toFixed(2) + ' will be added to the reserve balance.',
			icon: 'ri-money-dollar-circle-line',
			colorClass: 'success',
			confirmText: 'Yes, add',
		}).then((result) => {
			if (!result.value) return;

			this.reserveSaving = true;

			const payload = {
				campaign_id: this.reserveCampaign.id,
				amount: amount,
				user_id: this.user.IdUser,
			};

			this.campaignSrv.addReserveDeposit(payload).subscribe({
				next: () => {
					this.reserveSaving = false;
					this.reserveAmount = null;
					this.loadReserve();
				},
				error: () => {
					this.reserveSaving = false;
					this.resultAlert('Error', 'The deposit could not be saved.', 'ri-error-warning-line', 'danger');
				},
			});
		});
	}

	cancelReserveDeposit(movement: any) {
		this.confirmAction({
			title: 'Cancel this deposit?',
			text: 'The deposit of $' + Number(movement.amount).toFixed(2) + ' will no longer count toward the balance.',
			icon: 'ri-close-circle-line',
			colorClass: 'danger',
			confirmText: 'Yes, cancel it',
		}).then((result) => {
			if (!result.value) return;

			const payload = {
				movement_id: movement.id,
				user_id: this.user.IdUser,
			};

			this.campaignSrv.cancelReserveMovement(payload).subscribe({
				next: () => this.loadReserve(),
				error: () => this.resultAlert('Error', 'The deposit could not be canceled.', 'ri-error-warning-line', 'danger'),
			});
		});
	}
	// This method, deletes all record from assigned records, except the callbacks and
	assignRecordsToCampaign(campaign) {
		Swal.fire({
			title: 'Reset records for ' + campaign.name + '?',
			text: 'ARE YOU SURE? Please have all callers out of the selected campaign',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				Swal.fire({
					title: 'Reseting Records',
					text: '',
					confirmButtonText: 'Ok',
					didOpen: () => {
						Swal.showLoading();
						this.campaignSrv.assignRecordsToCampaign(campaign.id).subscribe((data) => {
							Swal.close();
							Swal.fire({
								title: 'Success',
								text: 'Records Reset',
								showCancelButton: false,
								confirmButtonText: 'Ok',
								cancelButtonText: 'Cancel',
							});
						});
					},
				});
			}
		});
	}

	recycleRecordsToCampaign(campaign) {
		this.confirmAction({
			title: 'Recycle records for ' + campaign.name + '?',
			text: 'ARE YOU SURE? Please have all callers out of the selected campaign',
			icon: 'ri-recycle-line',
			colorClass: 'success',
		}).then((result) => {
			if (!result.value) return;

			this.actionAlert.fire({
				title: 'Recycling Records',
				html: '<i class="ri-recycle-line swal-action-icon swal-icon-success"></i>',
				showConfirmButton: false,
				allowOutsideClick: false,
				didOpen: () => {
					Swal.showLoading();
					this.campaignSrv.recycleRecordsToCampaign(campaign.id).subscribe((data) => {
						Swal.close();
						this.resultAlert('Success', 'Records Recycled', 'ri-checkbox-circle-line', 'success');
					});
				},
			});
		});
	}

	editCampaign(campaign: any) {
		this.router.navigate(['campaign-edit'], {
			queryParams: { id: campaign.id },
		});
	}

	deactivateConfirm(campaign: any) {
		Swal.fire({
			title: 'Deactivate ' + campaign.name + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.deactivateCampaign(campaign);
			}
		});
	}

	deactivateCampaign(campaign: any) {
		this.resetLoading = true;
		this.campaignSrv.deactivateCampaign(campaign.id).subscribe(
			(data) => {
				Swal.fire({
					icon: 'success',
					title: 'Campaign correctly deactivated',
				});
				this.getAllCampaigns();
				this.resetLoading = false;
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error deactivating campaign',
					text: 'See the console for further information',
				});
				console.error('Error deactivating campaign:', error);
				this.resetLoading = false;
			},
		);
	}

	activateConfirm(campaign: any) {
		Swal.fire({
			title: 'Activate ' + campaign.name + '?',
			text: 'ARE YOU SURE?',
			showCancelButton: true,
			confirmButtonText: 'Yes',
			cancelButtonText: 'Cancel',
		}).then((result) => {
			if (result.value) {
				this.activateCampaign(campaign);
			}
		});
	}

	activateCampaign(campaign: any) {
		this.resetLoading = true;
		this.campaignSrv.activateCampaign(campaign.id).subscribe(
			(data) => {
				Swal.fire({
					icon: 'success',
					title: 'Campaign correctly activated',
				});
				this.getAllCampaigns();
				this.resetLoading = false;
			},
			(error) => {
				Swal.fire({
					icon: 'error',
					title: 'Error activating campaign',
					text: 'See the console for further information',
				});
				console.error('Error activating campaign:', error);
				this.resetLoading = false;
			},
		);
	}

	///falta la doble confirmación
	// deleteProspectsFromCampaign(campaign: any) {
	// 	Swal.fire({
	// 		title: 'Delete prospects',
	// 		text: 'Are you sure of delete prospects of this campaign?',
	// 		showCancelButton: true,
	// 		confirmButtonText: 'Yes',
	// 		cancelButtonText: 'Cancel',
	// 	}).then((data) => {
	// 		if (data.value) {
	// 			Swal.fire({
	// 				title: "This can't be revert",
	// 				text: 'Are you really sure of delete prospects of this campaign?',
	// 				showCancelButton: true,
	// 				confirmButtonText: 'Yes',
	// 				cancelButtonText: 'Cancel',
	// 			}).then((data) => {
	// 				if (data.value) {
	// 					this.unassignFromCampaign(campaign.id);
	// 				}
	// 			});
	// 		}
	// 	});
	// }

	deleteProspectsFromCampaign(campaign: any) {
		this.confirmAction({
			title: 'Delete prospects from ' + campaign.name + '?',
			text: 'Are you sure you want to delete the prospects of this campaign?',
			icon: 'ri-delete-bin-line',
			colorClass: 'danger',
		}).then((result) => {
			if (!result.value) return;

			this.confirmAction({
				title: "This can't be reverted",
				text: 'Are you really sure you want to delete the prospects of "' + campaign.name + '"?',
				icon: 'ri-delete-bin-line',
				colorClass: 'danger',
			}).then((result2) => {
				if (result2.value) {
					this.unassignFromCampaign(campaign.id);
				}
			});
		});
	}

	exportToExcel(): void {
		const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.activeCampaigns);
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
		const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
		const data: Blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
		saveAs(data, 'table.xlsx');
	}

	deleteRecords(campaignId: any) {
		return new Promise((resolve, reject) => {
			this.campaignSrv.deleteRecordsToCampaign(campaignId).then((data) => {
				resolve(data);
				if (data) {
					Swal.fire({
						position: 'center',
						icon: 'success',
						title: 'Records Deleted Successfully',
						showConfirmButton: false,
						timer: 2000,
					});
				}
			});
		});
	}

	updateFilter2(event, props: string) {
		const val = event.target.value.toLowerCase();
		const propArray = props.split(',');
		// filter our data
		const temp = this.temp.filter(function (d) {
			// Verifica si alguna de las propiedades contiene el valor buscado
			return propArray.some((prop) => {
				return d[prop].toLowerCase().indexOf(val) !== -1 || !val;
			});
		});

		// update the rows
		this.campaigns = temp;
		// Whenever the filter changes, always go back to the first page
		// this.table.offset = 0;
	}

	openCalendar(id, alias) {
		var url = this.router.url;
		var urlArray = url.split('/');
		url = `${urlArray[0]}/#/calendar/${alias}/${id}`;
		window.open(url, '_blank', 'location=no,height=825,width=1200,scrollbars=yes,status=yes');
	}

	unassignFromCampaign(campaign_id) {
		this.prospectSrv.unassignFromCampaign(campaign_id, 'ALL').subscribe((response: any) => {
			this.getAllCampaigns();
			Swal.fire({
				icon: 'success',
				title: 'Unassigned!',
				text: 'Prospects have been unassigned from the campaign.',
			});
		});
	}

	getIndustryDescription(industryId: number): string {
		const industry = INDUSTRIES.find((i) => i.id === industryId);
		return industry ? industry.description : '';
	}

	private confirmAction(opts: { title: string; text: string; icon: string; colorClass: 'primary' | 'warning' | 'success' | 'danger'; confirmText?: string }) {
		return this.actionAlert.fire({
			title: opts.title,
			html: `<i class="${opts.icon} swal-action-icon swal-icon-${opts.colorClass}"></i><div class="swal-action-text">${opts.text}</div>`,
			showCancelButton: true,
			confirmButtonText: opts.confirmText || 'Yes',
			cancelButtonText: 'Cancel',
			customClass: {
				popup: 'swal-action-popup',
				title: 'swal-action-title',
				htmlContainer: 'swal-action-text',
				confirmButton: `btn btn-${opts.colorClass} waves-effect waves-light`,
				cancelButton: 'btn btn-secondary waves-effect waves-light',
				actions: 'swal-action-buttons',
			},
		});
	}

	private resultAlert(title: string, text: string, icon: string, colorClass: 'success' | 'danger') {
		return this.actionAlert.fire({
			title,
			html: `<i class="${icon} swal-action-icon swal-icon-${colorClass}"></i><div class="swal-action-text">${text}</div>`,
			confirmButtonText: 'Ok',
			customClass: {
				popup: 'swal-action-popup',
				title: 'swal-action-title',
				htmlContainer: 'swal-action-text',
				confirmButton: `btn btn-${colorClass} waves-effect waves-light`,
			},
		});
	}

	sortBy(column: string) {
		if (this.sortColumn === column) {
			this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			this.sortColumn = column;
			this.sortDirection = 'asc';
		}

		this.campaigns = [...this.campaigns].sort((a, b) => {
			let valA = a[column];
			let valB = b[column];

			if (typeof valA === 'string') valA = valA.toLowerCase();
			if (typeof valB === 'string') valB = valB.toLowerCase();

			if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
			if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
			return 0;
		});
	}
}
